export const CREATE_EDIT_WORKSPACE_STEPS = {
  overview: 'Overview',
  hazards_and_scenarios: 'Hazards and scenarios',
  capitals: 'Capitals',
  contextual_layers: 'Contextual layers',
  live_layers: 'Live layers',
  areas: 'Areas',
  review_and_save: 'Review and save',
}
